import { axios } from '@/lib/axios';

export const getLoyaltyData = async (id: number) => {
    const { data } = await axios.get(`v1/get-corporation-loyalty-points/${id}`);
    return data;
};
